'use strict';

import template from './recent_bookings.html';

const pageSize = 6;
const controller = [
  '$stateParams',
  '$state',
  'recentBookings',
  'listingPrice',
  'placesService',
  'deslug',

  function ($stateParams, $state, recentBookings, listingPrice, placesService, deslug) {
    if ($stateParams.price === '0') {
      listingPrice.showPrice = false;
    }
    var self = this;
    this.showPrice = listingPrice.showPrice;
    recentBookings.reset();
    this.recentBookings = recentBookings;
    this.limit = 0;
    this.city = deslug.it($stateParams.city);

    this.showMore = function () {
      this.limit += pageSize;
      this.hasMore = recentBookings.list.length > this.limit;
    };

    self.fetchData = function () {
      this.isLoading = true;
      recentBookings.fetch()
        .then(() => {
          this.showMore();
        })
        .finally(() => {
          delete this.isLoading;
        });
    };

    if ($stateParams.placeId === undefined) {
      let currentCity = '';
      if ($stateParams.city !== undefined) {
        currentCity = $stateParams.city;
        //} else if ($state.current.name === 'guides.kiev') {
        //  currentCity = 'kyiv';
        //}
      }
      if (currentCity != '') {
        placesService.getPlaceId(currentCity).then((response) => {
          $stateParams.placeId = response.data.placeId;
          self.fetchData();
        });
      } else {
        self.fetchData();
      }
    } else {
      self.fetchData();
    }
  }
];

const saRecentBookings = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        cityPage: '<?'
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saRecentBookings;



// WEBPACK FOOTER //
// ./app/src/common/recent_bookings/recent_bookings.directive.js